import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Modules / Mixins
import isResizable from '../../../../mixins/resizable';

// Related Components
import AutoConfetti from './congratulations/auto_confetti';
import LogoutLogo from '../../../agents/subscribe/logout_logo';

class Congratulations extends React.Component {
  static propTypes = {
    isDesktop: PropTypes.bool,
  };

  render() {
    const { isDesktop } = this.props;

    return (
      <div className='width-100pct'>
        <AutoConfetti />
        <div className='height-60 margin-bottom-45'>
          <LogoutLogo />
        </div>
        <div id='congratulations' className='margin-center'>
          <div className='width-100pct flex justify-center'>
            <div className={classNames('margin-auto min-height-465 margin-bottom-80', {
              'flex': isDesktop,
            })}>
              <div className='width-440'>
                <div className='heading margin-bottom-25'>
                  <span className='thankyou margin-right-5'>Congratulations!</span><br />
                  We are getting<br />
                  your account ready
                </div>
                <div className='sub-heading'>
                  Our team is carefully reviewing your<br />
                  request to maintain the exclusivity<br />
                  and high standards of our well-vetted<br />
                  community. You will receive an<br />
                  activation link within next 24 hours!
                </div>
              </div>
              <div>
                <img src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/sign_up/congratulations.png`} width='90%' />
              </div>
            </div>
          </div>
          <div className='footer-header margin-bottom-50 flex justify-center'>Specialized Consultants in Top Technologies</div>
          <div className='width-100pct flex justify-center'>
            <img src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/sign_up/companies.png`} width='90%' />
          </div>
        </div>
      </div>
    )
  }
}

export default isResizable(Congratulations);
